import { useEffect, useState } from "react";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AllClosed from "./all-closed";
import ClosedTab from "./closed-tab";
import Cancelled from "./cancelled";
import eventBus from "../../../utils/EventBus";
import Notification from "../../../components/notification/notification";
import { useSelector } from "react-redux";
import { userType } from "../../../utils/Constant";
import ContactSpectrum from "../../../components/contact-spectrum/constact-spectrum";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function TabLabel(data: any) {
  return (
    <>
      {data?.label}
      {data?.showWarning && (
        <InfoOutlinedIcon className="tab-label-warning-icon" />
      )}
    </>
  );
}

export default function OrderClosed() {
  const [value, setValue] = useState(0);
  const [showSuccessNotification, setShowSuccessNotification] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const { currentUser } = useSelector((state: any) => state.user.user);

  useEffect(() => {
    eventBus.addListener("createIssuesSuccess", onCreateIssuesSuccess);
    return () => {
      eventBus.removeListener("createIssuesSuccess", onCreateIssuesSuccess);
    };
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const onCreateIssuesSuccess = () => {
    setSuccessMessage("Created Issues Successfully.");
    setShowSuccessNotification(true);
  };

  return (
    <>
      {currentUser?.userType !== userType.client && <ContactSpectrum />}
      <Box mt={currentUser?.userType === userType.client ? 2 : 0}>
        <Breadcrumb />
      </Box>
      <Typography sx={{ ml: 2, mt: 1 }} variant="h4">
        Closed
      </Typography>
      {currentUser?.userType === userType?.inspector ? (
        <AllClosed />
      ) : (
        <Box
          sx={{ mt: 3, mx: 2 }}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="orders tabs"
            variant="scrollable"
            scrollButtons={false}
          >
            <Tab
              className="tab-label"
              label={<TabLabel label="All" showWarning={false} />}
            />
            <Tab
              className="tab-label"
              label={<TabLabel label="Closed" showWarning={false} />}
            />
            <Tab
              className="tab-label"
              label={<TabLabel label="Cancelled" showWarning={false} />}
            />
          </Tabs>
        </Box>
      )}

      {currentUser?.userType !== userType?.inspector && (
        <>
          <CustomTabPanel value={value} index={0}>
            <AllClosed />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <ClosedTab />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <Cancelled />
          </CustomTabPanel>
        </>
      )}
      
      {showSuccessNotification && (
        <Notification
          show={showSuccessNotification}
          message={successMessage}
          onClose={() => setShowSuccessNotification(false)}
        />
      )}
    </>
  );
}
